/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import Header from '../../../Header/Header';
import Sidebar from '../../../Sidebar/Sidebar';
import Footer from '../../../Footer/Footer';
import { connect, useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
    changePage,
    get,
    order,
    change_qtd_per_page,
    changePesquisa,
    clearPesquisa,
} from './Actions/actions';
import { pagination } from '../../../Pagination/paginations';
import {
    delExtraCharge,
    changeStatus,
    exportExcelCSV,
} from '../../../Services/extraCharge';
import Pagination from '../../../Table/Pagination';
import Alert from '../../../Alerts/Alert';
import MyModal from '../../../Modal/MyModal';
import ModalLarge from '../../../Modal/ModalLarge';
import ReactLoading from 'react-loading';
import { Content } from '../../../LoadingStyle/StyleLoading';
import CabecalhoNew from '../../../Table/CabecalhoNew';
import Input from '../../../Forms/Input';
import TextArea from '../../../Forms/TextArea';
import Form from '../../../Forms/Form';
import AprovedIcon from '../../../Icons/emojione-v1_ballot-box-bold-check.png';
import ReprovedIcon from '../../../Icons/fluent_document-footer-remove-24-filled.png';
import IconAnalysys from '../../../Icons/cib_anaconda.png';
import ReportExtraCharge from './ReportExtraCharge';
import makeAnimated from 'react-select/animated';
import Select from 'react-select';
import ExtraCharges from './ExtraCharges';
import NumberFormat from 'react-number-format';
import { uniqueId } from 'lodash';
import Pagamento from './Pagamento';
import TablePagamento from './TablePagamento';
import { CSVLink } from 'react-csv';

function GridExtraCharge(props) {
    const [loading, setLoading] = useState(false);
    const [modal, setModal] = useState(false);
    const [description, setDescription] = useState('');
    const [modalReproved, setModalReproved] = useState(false);
    const [modalDisapproved, setModalDisapproved] = useState(false);
    const [modalAproved, setModalAproved] = useState(false);
    const [idExtraCharge, setIdExtraCharge] = useState('');
    const [extraCharge, setExtraCharge] = useState('');
    const [extraChargeCSV, setExtraChargeCSV] = useState([]);
    const [vencimentoParcela, setVencimentoParcela] = useState('');
    const [pagamento, setPagamento] = useState([]);
    const [pagamentoTotal, setPagamentoTotal] = useState(0);
    const [aprovedBlocked, setAprovedBlocked] = useState('');
    const [valorParcela, setValorParcela] = useState('');
    const [cliente, setCliente] = useState([]);
    const [id, setId] = useState('');
    const [success, setSuccess] = useState('');
    // const [ idClient, setIdClient ] = useState([])
    const [error, setError] = useState('');
    const [displayLegend, setDisplayLegend] = useState(true);
    const [modalFilter, setModalFilter] = useState(false);
    const from = useSelector((state) => state.extra_charge.from);
    const to = useSelector((state) => state.extra_charge.to);
    const dispatch = useDispatch();
    const [status_all, setStatusAll] = useState([]);
    const animatedComponents = makeAnimated();
    const [headers, setHeaders] = useState('');
    const fileUpload = useRef();

    const getExtraCharge = () => {
        props.get();
    };

    useEffect(() => {
        getExtraCharge();
        return () => {
            getExtraCharge();
        };
    }, []);

    const onChangeModal = (id_prod) => {
        setModal(true);
        setId(id_prod);
    };

    const handleCloseExcluir = (event) => {
        setModal(false);
        setId('');
        setCliente([]);
    };

    const handleExcluir = (e) => {
        e.preventDefault();
        setLoading(true);
        setModal(false);
        setCliente([]);
        delExtraCharge(id)
            .then((resp) => {
                setSuccess(resp.data.success);
                setError('');
                setLoading(false);
            })
            .then((resp) =>
                setTimeout(() => {
                    setSuccess('');
                }, 4000)
            )
            .catch((e) => {
                setLoading(false);
                setError(e.response.data.error);
                setSuccess('');
                setModal(false);
                setTimeout(() => {
                    setError('');
                }, 4000);
            })
            .then((resp) => props.get());
        // .then(resp => {setState({success:resp.data.success, error:''})})
    };

    const handlePagamento = (e) => {
        e.preventDefault();
        let total = pagamentoTotal + valorParcela;
        if (total > extraCharge.valor) {
            setAprovedBlocked(
                'Não é possível adicionar um valor maior que o valor total'
            );
        } else {
            setAprovedBlocked('');
            const data = {
                id: uniqueId(),
                dataPagamento: vencimentoParcela,
                valorParcela: valorParcela,
            };
            setPagamento(pagamento.concat(data));

            setPagamentoTotal(pagamentoTotal + valorParcela);

            setVencimentoParcela('');
            setValorParcela('');
        }
    };

    const handleDeletePagamento = (id) => {
        let valor = pagamento.filter((desc) => desc.id === id);
        setPagamento(pagamento.filter((desc) => desc.id !== id));

        setPagamentoTotal(pagamentoTotal - valor[0].valorParcela);
    };

    //Função que formata o campo valor
    function formatReal(desc) {
        var tmp = `${desc.toFixed(2)}`.replace('.', ',');

        if (tmp.length > 6)
            tmp = tmp.replace(/(([0-9]{3}),([0-9]{2}$)*)/g, '.$1');
        return tmp;
    }

    const changeStatusExtraChargeAproved = (e) => {
        e.preventDefault();

        if (pagamentoTotal !== extraCharge.valor) {
            return setAprovedBlocked(
                'O valor total das parcelas é diferente do valor do serviço extra'
            );
        }

        const ordenar = (a, b) => {
            return a.dataPagamento < b.dataPagamento
                ? -1
                : a.dataPagamento > b.dataPagamento
                ? 1
                : 0;
        };
        let pagamentoOrder = pagamento.sort(ordenar);

        setModalAproved(false);
        setLoading(true);
        setCliente([]);
        setPagamento([]);
        setPagamentoTotal(0);
        const object = {
            idStatus: 2,
            pagamento: pagamentoOrder,
        };
        changeStatus(extraCharge.id, object)
            .then((resp) => {
                setSuccess(resp.data.success);
                setError('');
                setLoading(false);
                setTimeout(() => {
                    setSuccess('');
                }, 4000);
            })
            .catch((e) => {
                setLoading(false);
                setError(e.response.data.errorSubmit);
                setSuccess('');
                setModal(false);
                setTimeout(() => {
                    setError('');
                }, 4000);
            })
            .then((resp) => props.get());
    };

    const modalReprovedOn = (idExtraCharge) => {
        setModalReproved(true);
        setIdExtraCharge(idExtraCharge);
    };

    const modalDisapprovedOn = (idExtraCharge) => {
        setModalDisapproved(true);
        setIdExtraCharge(idExtraCharge);
    };

    // const modalAprovedOn = (idExtraCharge) => {
    //     setModalAproved(true)
    //     setIdExtraCharge(idExtraCharge)
    // }

    const modalAprovedOn = (extraCharge) => {
        setModalAproved(true);
        setExtraCharge(extraCharge);
        setCliente(
            cliente.concat(
                extraCharge.clientes.map((desc) => ({
                    label: desc.cliente,
                    value: desc.id_cliente,
                }))
            )
        );
    };

    const handleCancelOrClose = () => {
        setModalAproved(false);
        setPagamento([]);
        setPagamentoTotal(0);
        setCliente([]);
    };

    const changeStatusExtraChargeReproved = (e) => {
        e.preventDefault();
        setModalReproved(false);
        setLoading(true);
        setCliente([]);
        setPagamento([]);
        setPagamentoTotal(0);
        const object = {
            idStatus: 3,
            description: description,
        };
        changeStatus(idExtraCharge, object)
            .then((resp) => {
                setSuccess(resp.data.success);
                setError('');
                setLoading(false);
                setDescription('');
                setTimeout(() => {
                    setSuccess('');
                }, 4000);
            })
            .catch((e) => {
                setLoading(false);
                setDescription('');
                setError(e.response.data.error);
                setSuccess('');
                setModal(false);
                setTimeout(() => {
                    setError('');
                }, 4000);
            })
            .then((resp) => props.get());
    };

    const changeStatusExtraChargeDisapproved = (e) => {
        e.preventDefault();
        setModalDisapproved(false);
        setLoading(true);
        setCliente([]);
        const object = {
            idStatus: 1,
        };
        changeStatus(idExtraCharge, object)
            .then((resp) => {
                setSuccess(resp.data.success);
                setError('');
                setLoading(false);
                setDescription('');
                setTimeout(() => {
                    setSuccess('');
                }, 4000);
            })
            .catch((e) => {
                setLoading(false);
                setDescription('');
                setError(e.response.data.error);
                setSuccess('');
                setModal(false);
                setTimeout(() => {
                    setError('');
                }, 4000);
            })
            .then((resp) => props.get());
    };

    const check = (event) => {
        let checked = event.target.checked;
        if (checked === true) {
            setStatusAll(status_all.concat(parseInt(event.target.value)));
        } else {
            setStatusAll(
                status_all.filter(
                    (desc) => parseInt(desc) !== parseInt(event.target.value)
                )
            );
        }
    };

    const exportCSV = (event) => {
        setHeaders([
            { label: 'Id Reg. Serviço Extra', key: 'id' },
            { label: 'Centro de Custo', key: 'centro_custo' },
            { label: 'Projeto', key: 'projeto' },
            { label: 'Usuário Resp. Cadastro', key: 'created' },
            { label: 'Status Reg. Serviço Extra', key: 'status' },
            { label: 'Usuário Responsável Aprovação', key: 'aproved' },
            { label: 'Id Registro Venda do Projeto', key: 'registroVenda' },
            { label: 'Código de Serviço Extra', key: 'codigo' },
            { label: 'Data Início Serviço Extra', key: 'data_inicio' },
            { label: 'Data Fim Serviço Extra', key: 'data_fim' },
            { label: 'Descrição do Serviço', key: 'descricao' },
            { label: 'Valor a ser cobrado do cliente', key: 'valor' },
            { label: 'Produto', key: 'produto' },
            { label: 'Valor Produto', key: 'produtoValor' },
            { label: 'Impostos', key: 'imposto' },
            { label: 'Margem Administrativa', key: 'margemAdm' },
            { label: 'Margem Líquida', key: 'margemLqd' },
            { label: 'Margem Adicional', key: 'margemAd' },
            { label: 'Técnico', key: 'tecnico' },
            { label: 'Dedicação (Dias)', key: 'dedicacao' },
            { label: 'Valor Diária', key: 'tecnicoValor' },
            { label: 'Id Projeto', key: 'id_projeto' },
        ]);

        exportExcelCSV(
            props.id_status ? props.id_status : '',
            props.id_coordinator ? props.id_coordinator : '',
            props.id_project ? props.id_project : '',
            props.from_date ? props.from_date : '',
            props.to_date ? props.to_date : ''
        )
            .then((resp) => {
                setExtraChargeCSV(resp.data);
            })
            .then((resp) => {
                fileUpload.current.link.click();
            });
    };

    return (
        <div className="wrapper" style={{ backgroundColor: '#E5E5E5, 100%' }}>
            <Header />
            <Sidebar />
            <div
                className="content-wrapper"
                style={{ backgroundColor: '#E5E5E5, 100%' }}
            >
                <section
                    className="content"
                    style={{ backgroundColor: '#E5E5E5, 100%' }}
                >
                    <MyModal
                        show={modal}
                        onHide={handleCloseExcluir}
                        title="Excluir Serviço Extra"
                        content="Tem certeza que deseja excluir o serviço extra ?"
                        cancel={handleCloseExcluir}
                        del={handleExcluir}
                        to="#/"
                        type="danger"
                        textButton="Excluir"
                    />
                    <div className="row">
                        <div className="col-md-12">
                            <MyModal
                                show={modalFilter}
                                onHide={(e) => setModalFilter(false)}
                                title="Filtrar"
                                content={<ReportExtraCharge />}
                                cancel={function () {
                                    return [
                                        props.clearPesquisa(),
                                        setTimeout(() => {
                                            setModalFilter(false);
                                        }, 1000),
                                    ];
                                }}
                                del={function () {
                                    return [
                                        props.get(),
                                        setTimeout(() => {
                                            setModalFilter(false);
                                        }, 1000),
                                    ];
                                }}
                                to="#/"
                                type="success"
                                contentSecondary="Limpar Busca"
                                textButton="Buscar"
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <MyModal
                                show={modalReproved}
                                onHide={(e) => setModalReproved(false)}
                                title="Reprovar Lançamento"
                                content={
                                    <Form
                                        onSubmit={
                                            changeStatusExtraChargeReproved
                                        }
                                    >
                                        <TextArea
                                            label="Motivo"
                                            maxLength="254"
                                            placeholder="Descreva o motivo da reprovação"
                                            onChange={(e) =>
                                                setDescription(e.target.value)
                                            }
                                            value={description}
                                            required={true}
                                        />
                                        <div className="text-right">
                                            <button
                                                style={{ marginRight: '10px' }}
                                                type="button"
                                                className="btn btn-secondary"
                                                onClick={(e) =>
                                                    setModalReproved(false)
                                                }
                                            >
                                                Cancelar
                                            </button>
                                            <button
                                                type="submit"
                                                className="btn btn-danger"
                                            >
                                                Reprovar
                                            </button>
                                        </div>
                                    </Form>
                                }
                                onSubmit={true}
                                cancel={(e) => setModalReproved(false)}
                                // del={changeStatusExtraChargeReproved}
                                to="#/"
                                type="danger"
                                textButton="Reprovar"
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <MyModal
                                show={modalDisapproved}
                                onHide={(e) => setModalDisapproved(false)}
                                title="Desaprovar Lançamento"
                                content={
                                    <Form
                                        onSubmit={
                                            changeStatusExtraChargeDisapproved
                                        }
                                    >
                                        <h3>
                                            Deseja realmente desaprovar esse
                                            lançamento?
                                        </h3>
                                        <div className="text-right">
                                            <button
                                                style={{ marginRight: '10px' }}
                                                type="button"
                                                className="btn btn-secondary"
                                                onClick={(e) =>
                                                    setModalDisapproved(false)
                                                }
                                            >
                                                Cancelar
                                            </button>
                                            <button
                                                type="submit"
                                                className="btn btn-danger"
                                            >
                                                Desaprovar
                                            </button>
                                        </div>
                                    </Form>
                                }
                                onSubmit={true}
                                cancel={(e) => setModalReproved(false)}
                                // del={changeStatusExtraChargeReproved}
                                to="#/"
                                type="danger"
                                textButton="Reprovar"
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <ModalLarge
                                show={modalAproved}
                                onHide={(e) => handleCancelOrClose()}
                                title="Aprovar Registro de Venda"
                                onSubmit={true}
                                cancel={(e) => setModalAproved(false)}
                                // del={changeStatusExtraChargeReproved}
                                to="#/"
                                type="success"
                                textButton="Aprovar"
                            >
                                <Form onSubmit={changeStatusExtraChargeAproved}>
                                    <div className="col-md-12">
                                        <div className="row">
                                            <div className="col-md-12 mt-3">
                                                <NumberFormat
                                                    label="Código W3"
                                                    name="code"
                                                    icon="fas fa-key"
                                                    fixedDecimalScale={true}
                                                    decimalScale={0}
                                                    thousandSeparator={''}
                                                    decimalSeparator={','}
                                                    placeholder=""
                                                    customInput={Input}
                                                    allowNegative={false}
                                                    value={
                                                        extraCharge.codigo_w3
                                                    }
                                                    required={true}
                                                    disabled={true}
                                                    // required={true}
                                                    // isAllowed={(values) => { const {floatValue,formattedValue} = values;  return formattedValue === "" || floatValue <= 999999999;}}
                                                />
                                            </div>
                                            <div className="col-md-12">
                                                <Input
                                                    label="Título do Projeto"
                                                    type="text"
                                                    icon="fas fa-heading"
                                                    value={extraCharge.projeto}
                                                    required={true}
                                                    disabled={true}
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <label>Clientes</label>
                                                <Select
                                                    value={cliente}
                                                    isMulti
                                                    name="Clientes"
                                                    // options={optionsClient}
                                                    components={
                                                        animatedComponents
                                                    }
                                                    closeMenuOnSelect={false}
                                                    className="basic-multi-select"
                                                    // ref={selectClientRef}
                                                    classNamePrefix="select"
                                                    // onChange={handleChangeClient}
                                                    isDisabled={true}
                                                />
                                            </div>
                                        </div>
                                        <div className="row mt-3">
                                            <div className="col-md-4">
                                                <Input
                                                    icon="fas fa-calendar"
                                                    label="Data Início *"
                                                    // min={}
                                                    // max={}
                                                    name="validity"
                                                    required={true}
                                                    type="date"
                                                    placeholder=""
                                                    disabled={true}
                                                    // onChange={}
                                                    value={
                                                        extraCharge.data_inicio_americano
                                                    }
                                                />
                                            </div>
                                            <div className="col-md-4">
                                                <Input
                                                    icon="fas fa-calendar"
                                                    label="Data Fim"
                                                    name="validity"
                                                    // min={}
                                                    // max={}
                                                    type="date"
                                                    required={true}
                                                    placeholder=""
                                                    disabled={true}
                                                    // onChange={}
                                                    value={
                                                        extraCharge.data_fim_americano
                                                    }
                                                />
                                            </div>
                                            <div className="col-md-4">
                                                <Input
                                                    icon="fas fa-calendar"
                                                    label="Período de Vigência"
                                                    type="text"
                                                    disabled={true}
                                                    value={`${extraCharge.vigencia_meses} meses`}
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <Input
                                                    icon="fas fa-dollar-sign"
                                                    label="Valor do serviço extra"
                                                    type="text"
                                                    disabled={true}
                                                    value={`R$${formatReal(
                                                        parseFloat(
                                                            extraCharge.valor
                                                        )
                                                    )}`}
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <TextArea
                                                    rows="3"
                                                    label="Descrição do valor das parcelas"
                                                    value={
                                                        extraCharge.descricao
                                                    }
                                                    maxLength="255"
                                                    disabled={true}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="text-right mt-4">
                                        <div
                                            style={{
                                                width: '100%',
                                                marginBottom: '20px',
                                                position: 'absolute',
                                                bottom: '0%',
                                                left: '-2%',
                                            }}
                                        >
                                            <button
                                                style={{ marginRight: '10px' }}
                                                type="button"
                                                className="btn btn-secondary"
                                                onClick={(e) =>
                                                    handleCancelOrClose()
                                                }
                                            >
                                                Cancelar
                                            </button>
                                            <button
                                                type="submit"
                                                className="btn btn-success"
                                            >
                                                Aprovar
                                            </button>
                                        </div>
                                    </div>
                                </Form>
                                <Form onSubmit={handlePagamento}>
                                    <div className="row">
                                        <div className="col-md-5">
                                            <Input
                                                icon="fas fa-calendar"
                                                label="Vencimento"
                                                name="validity"
                                                // min={}
                                                max={'2500-12-12'}
                                                type="date"
                                                required={true}
                                                placeholder=""
                                                disabled={false}
                                                onChange={(e) =>
                                                    setVencimentoParcela(
                                                        e.target.value
                                                    )
                                                }
                                                value={vencimentoParcela}
                                            />
                                        </div>

                                        <div className="col-md-5">
                                            <NumberFormat
                                                icon="fas fa-money-check-alt"
                                                label="Valor da parcela"
                                                name="value"
                                                required={true}
                                                allowNegative={false}
                                                fixedDecimalScale={true}
                                                decimalScale={2}
                                                thousandSeparator={'.'}
                                                decimalSeparator={','}
                                                placeholder=""
                                                customInput={Input}
                                                onChange={(e) =>
                                                    setValorParcela(
                                                        parseFloat(
                                                            e.target.value
                                                                .replace(
                                                                    '.',
                                                                    ''
                                                                )
                                                                .replace(
                                                                    '.',
                                                                    ''
                                                                )
                                                                .replace(
                                                                    ',',
                                                                    '.'
                                                                )
                                                        )
                                                    )
                                                }
                                                value={valorParcela}
                                                disabled={false}
                                                isAllowed={(values) => {
                                                    const {
                                                        floatValue,
                                                        formattedValue,
                                                    } = values;
                                                    return (
                                                        formattedValue === '' ||
                                                        floatValue <= 9999999
                                                    );
                                                }}
                                            />
                                        </div>
                                        <div className="col-md-2">
                                            <div
                                                className="input-group mb-3"
                                                style={{ paddingTop: '30px' }}
                                            >
                                                <button
                                                    disabled={
                                                        props.match.params
                                                            .action === 'view'
                                                            ? true
                                                            : false
                                                    }
                                                    type="submit"
                                                    className="btn btn-primary"
                                                >
                                                    <span className="fas fa-plus"></span>
                                                </button>
                                            </div>
                                        </div>
                                        {/* <div className="col-md-3">
                                            <NumberFormat   
                                                        icon="fas fa-money-check-alt"
                                                        label="Valor da parcela"
                                                        name="value" 
                                                        required={true}
                                                        allowNegative={false}
                                                        fixedDecimalScale={true}
                                                        decimalScale={2}
                                                        thousandSeparator={"."} 
                                                        decimalSeparator={","}
                                                        placeholder=""
                                                        customInput={Input}
                                                        onChange={(e) => setValorParcela(parseFloat(e.target.value.replace('.','').replace('.','').replace(',','.')))} 
                                                        value={valorParcela}
                                                        disabled={false}
                                                        isAllowed={(values) => { const {floatValue,formattedValue} = values;  return formattedValue === "" || floatValue <= 9999999;}}                          
                                                    />
                                        </div> */}
                                    </div>
                                    {aprovedBlocked ? (
                                        <Alert type="danger">
                                            {aprovedBlocked}
                                        </Alert>
                                    ) : (
                                        ''
                                    )}
                                    <TablePagamento
                                        total={`R$${formatReal(
                                            parseFloat(pagamentoTotal)
                                        )}`}
                                    >
                                        <Pagamento
                                            isDisabled={
                                                props.match.params.action ===
                                                'view'
                                                    ? true
                                                    : false
                                            }
                                            pagamento={pagamento}
                                            formatReal={formatReal}
                                            handleDeletePagamento={
                                                handleDeletePagamento
                                            }
                                        />
                                    </TablePagamento>
                                </Form>
                            </ModalLarge>
                        </div>
                    </div>
                    {loading === true ? (
                        <Content>
                            <ReactLoading
                                type="spinningBubbles"
                                color="blue"
                                height={200}
                                width={100}
                            />
                        </Content>
                    ) : (
                        ''
                    )}
                    <div
                        style={{ display: loading === true ? 'none' : 'block' }}
                    >
                        <div className="row mt-3">
                            <div className="col-md-12">
                                <div className="box">
                                    <div
                                        className="box-body"
                                        style={{
                                            background: '#FFFFFF',
                                            boxShadow:
                                                '0px 4px 4px rgba(0, 0, 0, 0.25)',
                                            padding: '15px',
                                        }}
                                    >
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <h2>
                                                    Registros de Serviços Extras
                                                </h2>
                                            </div>
                                            <div className="text-right col-sm-6">
                                                <button
                                                    type="button"
                                                    onClick={(e) => {
                                                        props.history.push(
                                                            `/new_extra_charge`
                                                        );
                                                        e.preventDefault();
                                                    }}
                                                    className="btn btn-primary"
                                                >
                                                    Cadastro
                                                </button>
                                            </div>
                                        </div>
                                        {props.extraCharge.length >= 0 ||
                                        props.pesquisa ? (
                                            <CabecalhoNew
                                                filter={
                                                    <>
                                                        <div className="col-md-3 col-sm-12 mt-3">
                                                            <Input
                                                                label="De"
                                                                type="date"
                                                                icon="fas fa-calendar"
                                                                onChange={(e) =>
                                                                    dispatch({
                                                                        type: 'changeFromReportExtraCharge',
                                                                        payload:
                                                                            e
                                                                                .target
                                                                                .value,
                                                                    })
                                                                }
                                                                value={from}
                                                            />
                                                        </div>
                                                        <div className="col-md-3 col-sm-12 mt-3">
                                                            <Input
                                                                label="Até"
                                                                type="date"
                                                                icon="fas fa-calendar"
                                                                max={to}
                                                                onChange={(e) =>
                                                                    dispatch({
                                                                        type: 'changeToReportExtraCharge',
                                                                        payload:
                                                                            e
                                                                                .target
                                                                                .value,
                                                                    })
                                                                }
                                                                value={to}
                                                            />
                                                        </div>
                                                    </>
                                                }
                                                buttonCsv={
                                                    <>
                                                        <button
                                                            style={{
                                                                background:
                                                                    '#005F31',
                                                                color: '#FFF',
                                                                borderRadius:
                                                                    '20.5px',
                                                                width: '140px',
                                                            }}
                                                            className="btn btn-sm"
                                                            onClick={exportCSV}
                                                        >
                                                            <i className="fas fa-file-csv"></i>{' '}
                                                            Exportar CSV
                                                        </button>
                                                        <button
                                                            style={{
                                                                background:
                                                                    '#1A170E',
                                                                color: '#FFF',
                                                                borderRadius:
                                                                    '20.5px',
                                                                width: '140px',
                                                                marginLeft:
                                                                    '10px',
                                                            }}
                                                            className="btn btn-sm"
                                                            onClick={() =>
                                                                setModalFilter(
                                                                    modalFilter ===
                                                                        false
                                                                        ? true
                                                                        : false
                                                                )
                                                            }
                                                        >
                                                            <i className="fas fa-filter"></i>{' '}
                                                            Mais Filtros
                                                        </button>
                                                        <CSVLink
                                                            filename={`Relatorio-${new Date()}.csv`}
                                                            headers={headers}
                                                            hidden={true}
                                                            separator={';'}
                                                            ref={fileUpload}
                                                            data={
                                                                extraChargeCSV ||
                                                                []
                                                            }
                                                        >
                                                            <span className="fas fa-file-csv">
                                                                {' '}
                                                                Exportar CSV
                                                            </span>
                                                        </CSVLink>
                                                    </>
                                                }
                                                to="#/"
                                                action={props.get}
                                                clear={props.clearPesquisa}
                                                valuePesquisa={props.pesquisa}
                                                value={props.qtd_per_page}
                                                onChange={
                                                    props.change_qtd_per_page
                                                }
                                                changePesquisa={
                                                    props.changePesquisa
                                                }
                                            />
                                        ) : (
                                            ''
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            <div
                                style={{
                                    display: `${
                                        displayLegend === true
                                            ? 'none'
                                            : 'block'
                                    }`,
                                }}
                                className="text-right"
                            >
                                <button
                                    onClick={(e) => setDisplayLegend(true)}
                                    className="btn"
                                    style={{
                                        background:
                                            'linear-gradient(99.87deg, #427B67 25.78%, #22AC7A 65.59%)',
                                        borderRadius: '20.5px',
                                    }}
                                >
                                    Legendas
                                </button>
                            </div>
                            <div
                                style={{
                                    backgroundColor: '#FFF',
                                    padding: '10px',
                                    borderRadius: '25px',
                                    display: `${
                                        displayLegend === false
                                            ? 'none'
                                            : 'block'
                                    }`,
                                }}
                            >
                                <div
                                    style={{
                                        position: 'relative',
                                        float: 'right',
                                    }}
                                >
                                    <button
                                        onClick={(e) => setDisplayLegend(false)}
                                        className="btn"
                                    >
                                        <i className="fas fa-times"></i>
                                    </button>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-md-2 mt-2">
                                        <h5 style={{ fontSize: '16px' }}>
                                            Legendas:
                                        </h5>
                                    </div>
                                    <div className="col-md-3 mt-2">
                                        <span>
                                            <img
                                                src={IconAnalysys}
                                                width="20px"
                                                alt="Analise"
                                            />{' '}
                                            Em Análise
                                        </span>
                                    </div>
                                    <div className="col-md-3 mt-2">
                                        <span>
                                            <img
                                                src={AprovedIcon}
                                                width="20px"
                                                alt="Aprovar"
                                            />{' '}
                                            Aprovar
                                        </span>
                                    </div>
                                    <div className="col-md-3 mt-2">
                                        <span>
                                            <img
                                                src={ReprovedIcon}
                                                width="20px"
                                                alt="Reprovar"
                                            />{' '}
                                            Reprovar
                                        </span>
                                    </div>
                                    {/* <div className="col-md-1 mt-2">
                                        <span><img src={IconBilled} width="20px" /> Faturar</span>

                                    </div> */}
                                </div>
                            </div>
                            {success ? (
                                <Alert type="success">{success}</Alert>
                            ) : (
                                ''
                            )}
                            {error ? <Alert type="danger">{error}</Alert> : ''}
                            <div className="row mt-3">
                                {parseInt(props.extraCharge.length) === 0 ? (
                                    <div
                                        style={{
                                            color: '#FFFF',
                                            textAlign: 'center',
                                            width: '100%',
                                        }}
                                    >
                                        <span style={{ color: 'black' }}>{`${
                                            !props.pesquisa
                                                ? 'Não existem Serviços Extras cadastradas no sistema. Clique no botão Cadastro para inserir um novo Registro de Serviço Extra no sistema'
                                                : 'Nenhum registro encontrado na pesquisa'
                                        }`}</span>
                                    </div>
                                ) : (
                                    ''
                                )}
                                {/* <ExtraCharges changeStatusExtraChargeAproved={changeStatusExtraChargeAproved} check={check} modalReprovedOn={modalReprovedOn} history={props.history} check={check} extraCharges={props.extraCharge} formatReal={formatReal} onDelete={onChangeModal} /> */}
                                <ExtraCharges
                                    modalAprovedOn={modalAprovedOn}
                                    modalReprovedOn={modalReprovedOn}
                                    modalDisapprovedOn={modalDisapprovedOn}
                                    history={props.history}
                                    check={check}
                                    extraCharges={props.extraCharge}
                                    formatReal={formatReal}
                                    onDelete={onChangeModal}
                                />
                            </div>
                        </div>
                        {props.extraCharge.length > 0 && (
                            <div className="row mt-4">
                                <div className="col-md-12">
                                    <div className="box">
                                        <div
                                            className="box-body"
                                            style={{
                                                background: '#FFFFFF',
                                                boxShadow:
                                                    '0px 4px 4px rgba(0, 0, 0, 0.25)',
                                                padding: '15px',
                                            }}
                                        >
                                            <div className="row mt-4">
                                                <div className="col-md-1">
                                                    <select
                                                        value={
                                                            props.qtd_per_page
                                                        }
                                                        onChange={
                                                            props.change_qtd_per_page
                                                        }
                                                        name="example1_length"
                                                        aria-controls="example1"
                                                        className="custom-select custom-select-sm form-control form-control-sm"
                                                    >
                                                        <option value={8}>
                                                            8
                                                        </option>
                                                        <option value={24}>
                                                            24
                                                        </option>
                                                        <option value={48}>
                                                            48
                                                        </option>
                                                        <option value={96}>
                                                            96
                                                        </option>
                                                    </select>
                                                </div>
                                                <div className="col-md-5 mt-1 mb-2">
                                                    Exibindo de {props.from} à{' '}
                                                    {props.to} do total de{' '}
                                                    {props.qtd_total}
                                                </div>
                                                <div className="col-md-6 col-sm-12">
                                                    <div
                                                        style={{
                                                            float: 'right',
                                                        }}
                                                    >
                                                        <Pagination>
                                                            {props.pagination(
                                                                props.current_page,
                                                                props.get,
                                                                props.last_page,
                                                                props.changePage
                                                            )}
                                                        </Pagination>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </section>
            </div>
            <Footer />
        </div>
    );
}

const mapStateToProps = (state) => ({
    extraCharge: state.extra_charge.extra_charges.data || [],
    current_page: state.extra_charge.extra_charges.current_page,
    perfis: state.auth.user.perfis,
    last_page: state.extra_charge.extra_charges.last_page,
    from: state.extra_charge.extra_charges.from,
    to: state.extra_charge.extra_charges.to,
    qtd_total: state.extra_charge.extra_charges.total,
    qtd_per_page: state.extra_charge.qtd_per_page,
    pesquisa: state.extra_charge.pesquisa || '',
    id_role: state.auth.user.id_role,
    asc: state.extra_charge.asc,
    th: state.extra_charge.th,
    id_coordinator: state.extra_charge.coordinator_report.value || '',
    id_project: state.extra_charge.project_report.value || '',
    id_status: state.extra_charge.status_report.value || '',
    from_date: state.extra_charge.from,
    to_date: state.extra_charge.to,
    order_var: state.extra_charge.order,
});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            pagination,
            get,
            order,
            change_qtd_per_page,
            changePesquisa,
            clearPesquisa,
            changePage,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(GridExtraCharge);
